"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeDirectDebitAmountUI = void 0;
var nebula_1 = require("@ovotech/nebula");
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var __generated__1 = require("../../../../../shared/api/kapi/v1/__generated__/");
var core_1 = require("../../../../../shared/core");
var money_1 = require("../../../../../shared/core/utils/money");
var analytics_subjects_1 = require("../../../analytics-subjects");
var constants_1 = require("../../../constants");
var copy_1 = require("../../../copy");
var data_1 = require("../../../data");
var section_ids_1 = require("../../../section-ids");
var utils_1 = require("../../../utils");
var components_1 = require("./components");
var DirectDebitOptions;
(function (DirectDebitOptions) {
    DirectDebitOptions["RECOMMENDED"] = "recommended_DD";
    DirectDebitOptions["COVID_HARDSHIP_SCHEME"] = "covid-scheme";
    DirectDebitOptions["OTHER"] = "other";
})(DirectDebitOptions || (DirectDebitOptions = {}));
var ChangeDirectDebitAmountUI = function (_a) {
    var _b;
    var accountId = _a.accountId, customerId = _a.customerId, directDebit = _a.directDebit, recommendedDirectDebit = _a.recommendedDirectDebit;
    var navigate = (0, ui_tools_1.useNavigate)();
    var _c = (0, core_1.useLinks)(), payments = _c.payments, updateDirectDebitAmountConfirmation = _c.updateDirectDebitAmountConfirmation;
    var search = window.location.search;
    var amountFromParams = (0, core_1.getValueFromQueryParams)('amount', search);
    var _d = (0, core_1.useComponents)(), CurrencyField = _d.CurrencyField, PrimaryCTAButton = _d.PrimaryCTAButton, ErrorSection = _d.ErrorSection, ErrorSummaryNotification = _d.ErrorSummaryNotification, PageLayout = _d.PageLayout, Margin = _d.Margin, Stack = _d.Stack, ButtonGroup = _d.ButtonGroup, Redirect = _d.Redirect;
    var _e = (0, core_1.useCopy)(copy_1.defaultOptions), Copy = _e.Copy, copy = _e.copy;
    var _f = __read((0, react_1.useState)(false), 2), apiError = _f[0], setApiError = _f[1];
    var retailer = core_1.configService.getConfig().retailer;
    var currencyCode = (0, utils_1.getCurrency)(retailer.currencyCode).code;
    var statusList = (recommendedDirectDebit && recommendedDirectDebit.state) || [];
    var hasProblematicRecommendationStatus = statusList.includes('AccountInLoss') ||
        statusList.includes('RecentlyOnboarded') ||
        statusList.includes('BillingOnHold') ||
        statusList.includes('AmountOverSensibleUpperLimit');
    var numericRecommendedDirectDebit = (0, utils_1.recommendedDirectDebitAsNumber)(recommendedDirectDebit);
    var directDebitAmount = directDebit.amount
        ? (0, utils_1.getPoundValueAsNumber)(directDebit.amount).toString()
        : '';
    var recommendedAmount = numericRecommendedDirectDebit && !hasProblematicRecommendationStatus
        ? numericRecommendedDirectDebit.toString()
        : directDebitAmount;
    var paramAmount = (0, utils_1.getDefaultAmount)(amountFromParams);
    var _g = __read((0, react_1.useState)(paramAmount ? paramAmount : recommendedAmount), 2), amount = _g[0], setAmount = _g[1];
    var _h = __read((0, react_1.useState)([]), 2), errors = _h[0], setErrors = _h[1];
    var _j = (0, data_1.useChangePaymentAmount)({ customerId: customerId, accountId: accountId }), directDebitAmountMutation = _j.mutate, loading = _j.loading;
    if (!directDebit.amount) {
        return react_1.default.createElement(Redirect, { to: payments() });
    }
    var isDebtRisk = !!recommendedDirectDebit &&
        (0, utils_1.getNegative)(constants_1.BALANCE_THRESHOLD_LARGE_POSITIVE) >
            Number(recommendedDirectDebit.predictedFinalBalance.amount) &&
        (0, utils_1.getNegative)(constants_1.BALANCE_THRESHOLD_SMALL_POSITIVE) <
            Number(recommendedDirectDebit.predictedFinalBalance.amount);
    var hasValidRecommendation = !!recommendedDirectDebit && recommendedDirectDebit.friendlyAmount != null;
    var hasEocDebt = !!recommendedDirectDebit &&
        recommendedDirectDebit.predictedFinalBalance !== undefined &&
        (0, money_1.getCurrencyValueAsNumber)({ unit: 'GBP' }, recommendedDirectDebit.predictedFinalBalance) < 0;
    var payingRightAmountApprox = !!recommendedDirectDebit &&
        recommendedDirectDebit.friendlyAmount !== undefined &&
        (0, utils_1.recDdApproxEqualToCurrentDd)(recommendedDirectDebit.friendlyAmount, directDebit.amount);
    var showRiskBanner = isDebtRisk &&
        recommendedDirectDebit &&
        recommendedDirectDebit.friendlyAmount !== null &&
        !hasProblematicRecommendationStatus;
    var minimumDD = numericRecommendedDirectDebit && !hasProblematicRecommendationStatus
        ? numericRecommendedDirectDebit
        : directDebit.amount
            ? Number(directDebit.amount.amount)
            : constants_1.MIN_DD_AMOUNT;
    var minimumDirectDebitAmount = (0, core_1.major0DP)((0, core_1.majorToMinor)(minimumDD));
    var analyticsPropsRaw = {
        recommendedDirectDebit: numericRecommendedDirectDebit,
        currentDirectDebit: directDebit.amount.amount,
    };
    var handleAmountChange = function (_a) {
        var value = _a.currentTarget.value;
        setAmount(value);
    };
    var handleSubmit = function (event) {
        event.preventDefault();
        setErrors([]);
        if (loading) {
            return;
        }
        var numericAmount = Number(amount);
        var isInRange = (0, utils_1.isAmountInRange)(amount, minimumDD);
        if (!isInRange || !Number.isInteger(numericAmount)) {
            setErrors([
                {
                    id: 'amount',
                    message: copy('changeDirectDebitErrorRange', {
                        minimumDD: minimumDirectDebitAmount,
                        maximumDD: (0, core_1.major0DP)((0, core_1.majorToMinor)(constants_1.MAX_DD_AMOUNT)),
                    }),
                },
            ]);
        }
        else if (directDebit.amount &&
            numericAmount === Number(directDebit.amount.amount)) {
            setErrors([
                {
                    id: 'amount',
                    message: copy('changeDirectDebitErrorSameValue'),
                },
            ]);
        }
        else {
            directDebitAmountMutation(
            // hardcode currency in v1/v2
            { amount: { currency: __generated__1.CurrencyInput.Gbp, value: amount } }, {
                onCompleted: function (response) {
                    navigate({
                        pathname: updateDirectDebitAmountConfirmation(),
                        search: "?".concat((0, utils_1.createConfirmParams)(response)),
                    });
                },
                onError: function () {
                    setApiError(true);
                },
            });
        }
    };
    var currencyFieldHint = copy('changeDirectDebitCurrencyFieldHint', {
        minimumDirectDebitAmount: minimumDirectDebitAmount,
    });
    return (react_1.default.createElement("section", { id: section_ids_1.CHANGE_DD_AMOUNT_SECTION_ID, "data-testid": section_ids_1.CHANGE_DD_AMOUNT_SECTION_ID },
        apiError ? react_1.default.createElement(ErrorSection, { id: section_ids_1.CHANGE_DD_AMOUNT_ERROR }) : null,
        react_1.default.createElement(ErrorSummaryNotification, { id: "error-summary", errors: errors }),
        react_1.default.createElement(PageLayout, { pageId: section_ids_1.CHANGE_DD_AMOUNT_SECTION_ID, heading: react_1.default.createElement(Copy, { copyKey: "changeDirectDebitHeading" }), backLink: payments(), backLinkLabel: react_1.default.createElement(Copy, { copyKey: "backtoPaymentsBreadcrumb" }) },
            react_1.default.createElement(Stack, { spaceBetween: [2, 4] },
                recommendedDirectDebit && showRiskBanner ? (react_1.default.createElement(components_1.DebtRiskBanner, { directDebitAmount: directDebit.amount, isVariable: recommendedDirectDebit.isVariable, endOfContract: recommendedDirectDebit.calculationEndDate })) : null,
                react_1.default.createElement(components_1.DDStateMessage, { recommendedDirectDebit: recommendedDirectDebit }),
                recommendedDirectDebit ? (react_1.default.createElement(components_1.PlanProjection, { recommendedDirectDebit: recommendedDirectDebit, isDebtRisk: isDebtRisk, hasEocDebt: hasEocDebt, payingRightAmountApprox: payingRightAmountApprox, hasValidRecommendation: hasValidRecommendation, hasProblematicRecommendationStatus: hasProblematicRecommendationStatus, directDebitAmount: directDebit.amount, directDebitDay: directDebit.dayOfMonth })) : null,
                react_1.default.createElement("form", { onSubmit: handleSubmit },
                    react_1.default.createElement(Margin, { vertical: 6 },
                        react_1.default.createElement(CurrencyField, { "data-testid": "currency-field-change-dd", label: copy('changeDirectDebitCurrencyFieldLabel'), id: "amount", value: amount, disabled: loading, onChange: handleAmountChange, error: (0, nebula_1.getErrorMessage)('amount', errors), hint: currencyFieldHint, min: minimumDD, max: constants_1.MAX_DD_AMOUNT, characters: 8, currency: currencyCode })),
                    react_1.default.createElement(ButtonGroup, null,
                        react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.CHANGE_DD_AMOUNT_BUTTON, properties: __assign(__assign({}, analyticsPropsRaw), (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b.amount = amount, _b.selectedMode = amount > recommendedAmount
                                ? DirectDebitOptions.OTHER
                                : DirectDebitOptions.RECOMMENDED, _b)) },
                            react_1.default.createElement(PrimaryCTAButton, { "data-testid": "change-dd-button", onClick: handleSubmit, loading: loading },
                                react_1.default.createElement(Copy, { copyKey: "changeDirectDebitChangeDdButton" }))))),
                recommendedDirectDebit &&
                    hasValidRecommendation &&
                    !hasProblematicRecommendationStatus ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Margin, { vertical: 6, "data-testid": "recommendation-explanation" },
                        react_1.default.createElement(components_1.RecommendationExplanation, { recommendedDirectDebit: recommendedDirectDebit })),
                    react_1.default.createElement(Copy, { copyKey: "changeDirectDebitRecommendationBody" }))) : null))));
};
exports.ChangeDirectDebitAmountUI = ChangeDirectDebitAmountUI;
